module.exports = __webpack_public_path__ + "img/icon-restaurant-menu.a55f3978.png";